import { styled, Box, Typography } from "@mui/material";
import React from "react";

const TitleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  border: "1px solid",
  padding: "24px",
  borderColor: theme.palette.grey[100],

  [theme.breakpoints.down("md")]: {
    gap: "6px",
    padding: "16px",
  },
}));

interface PageTitleProps {
  title: string;
  subtitle: string;
  imageUrl?: string;
  titleId?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, subtitle, imageUrl, titleId }) => {
  return (
    <TitleContainer
      sx={() => ({
        background: `url(${imageUrl}) no-repeat 95% center / contain, #fff`,
      })}
    >
      <Box
        sx={(theme) => ({
          width: "32px",
          height: "4px",
          background: theme.palette.secondary.main,
        })}
      />

      <Typography
        color="common.black"
        variant="h4"
        id={titleId}
        sx={{ fontSize: { xs: "20px", md: "24px" } }}
      >
        {title}
      </Typography>
      <Typography
        color="grey.600"
        variant="bodyLargeWeightRegular"
        sx={{ fontSize: { xs: "14px", md: "16px" } }}
      >
        {subtitle}
      </Typography>
    </TitleContainer>
  );
};

export default PageTitle;
